import React, { useEffect, useMemo, useState } from 'react'
import Breadcrumb from '../../components/common/Breadcrumb'
import ReactDataTable from 'react-data-table-component';
import { IconEdit, IconTrash } from '@tabler/icons-react';
import axios from 'axios';
import { insertUserRoles } from '../../services/dataService';
import CustomAlert from "../../components/common/CustomAlert";

export default function UserRole() {

    const [addUserRoleModal, setAddUserRoleModal] = useState(false)
    const openAddUserRoleModal = () => {
        setAddUserRoleModal(!addUserRoleModal)
    }

    const [showMsg, setShowMsg] = useState(false);
    const [msg,setMsg] = useState()
  const [error, setError] = useState();
    const [success, setSuccess] = useState();
  
  
    const [userRoleData, setUserRoleData] = useState({
        Id: '',
        Name: 'sdfvas',
        Narration: 'asdvsa',
        Code: 'ssf',
        ProfitCenterId: "8C9ECCF2-E2D0-4368-8E8A-3A83EC8C7EFE",
        UserId: '8C9ECCF2-E2D0-4368-8E8A-3A83EC8C7EFE',
        // Systime: new Date().toISOString(),
        // UserRoleName: 'asdf',
        // UserRoleHead: 'asfd',
        // TotalEmployee: 10,
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setUserRoleData((prev) => ({
          ...prev,
          [name]: value,
        }));
      };
    const handleSubmit = async () => {
        const formData = new FormData();
        Object.keys(userRoleData).forEach((key) => {
          formData.append(key, userRoleData[key]);
        });
    
        try {
          const response = insertUserRoles(userRoleData)
          
          
          console.log('UserRole added successfully:', response.data);
          // alert('UserRole added successfully!');
          setMsg(response.data?.message)
          setShowMsg(true);
          

          openAddUserRoleModal(); // Close the modal
        } catch (error) {
          console.error('Error adding userRole:', error);
          alert('Error adding userRole. Please try again.');
        }
      };
    

    useEffect(() => {
        document.body.classList[addUserRoleModal ? "add" : "remove"]("overflow-hidden")
    }, [addUserRoleModal])

    const columnsFilter = [
        {
            name: '#',
            selector: row => row.number,
            sortable: true,
        },
        {
            name: 'UserRole Name',
            selector: row => row.name,
            sortable: true,
        },
        {
            name: 'UserRole Head',
            selector: row => row.head,
            sortable: true,
        },
        {
            name: 'Total Employee',
            selector: row => row.totalEmployee,
            sortable: true,
        },
        {
            name: 'Action',
            selector: row => row.action,
        },
    ];

    const dataFilter = [
        {
            number: '1',
            name: 'Web Development',
            head: 'John Smith',
            totalEmployee: '305',
            action:
                <div className='flex items-stretch gap-10'>
                    <button className='bg-sky rounded-[4px] px-10 py-[8px]'>
                        <IconEdit className='text-white w-[18px] h-[18px]' />
                    </button>
                    <button className='bg-danger rounded-[4px] px-10 py-[8px]'>
                        <IconTrash className='text-white w-[18px] h-[18px]' />
                    </button>
                </div>
        },
        {
            number: '2',
            name: 'Marketing',
            head: 'Maryam Amiri',
            totalEmployee: '26',
            action:
                <div className='flex items-stretch gap-10'>
                    <button className='bg-sky rounded-[4px] px-10 py-[8px]'>
                        <IconEdit className='text-white w-[18px] h-[18px]' />
                    </button>
                    <button className='bg-danger rounded-[4px] px-10 py-[8px]'>
                        <IconTrash className='text-white w-[18px] h-[18px]' />
                    </button>
                </div>
        },
        {
            number: '3',
            name: 'App Development',
            head: 'Frank Camly',
            totalEmployee: '38',
            action:
                <div className='flex items-stretch gap-10'>
                    <button className='bg-sky rounded-[4px] px-10 py-[8px]'>
                        <IconEdit className='text-white w-[18px] h-[18px]' />
                    </button>
                    <button className='bg-danger rounded-[4px] px-10 py-[8px]'>
                        <IconTrash className='text-white w-[18px] h-[18px]' />
                    </button>
                </div>
        },
        {
            number: '4',
            name: 'Support',
            head: 'Gary Camara',
            totalEmployee: '45',
            action:
                <div className='flex items-stretch gap-10'>
                    <button className='bg-sky rounded-[4px] px-10 py-[8px]'>
                        <IconEdit className='text-white w-[18px] h-[18px]' />
                    </button>
                    <button className='bg-danger rounded-[4px] px-10 py-[8px]'>
                        <IconTrash className='text-white w-[18px] h-[18px]' />
                    </button>
                </div>
        },
        {
            number: '5',
            name: 'Accounts',
            head: 'Fidel Tonn',
            totalEmployee: '8',
            action:
                <div className='flex items-stretch gap-10'>
                    <button className='bg-sky rounded-[4px] px-10 py-[8px]'>
                        <IconEdit className='text-white w-[18px] h-[18px]' />
                    </button>
                    <button className='bg-danger rounded-[4px] px-10 py-[8px]'>
                        <IconTrash className='text-white w-[18px] h-[18px]' />
                    </button>
                </div>
        },
    ]

    const [filterText, setFilterText] = React.useState('');
    const [resetPaginationToggle, setResetPaginationToggle] = React.useState(false);
    const filteredItems = dataFilter.filter(
        item =>
            item.number.toLowerCase().includes(filterText.toLowerCase()) ||
            item.name.toLowerCase().includes(filterText.toLowerCase()) ||
            item.head.toLowerCase().includes(filterText.toLowerCase()) ||
            item.totalEmployee.toLowerCase().includes(filterText.toLowerCase())
    );

    const subHeaderComponentMemo = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText('');
            }
        };

        return (
            <div className='flex gap-5 mb-10 w-full justify-end'>
                <div className='relative w-full max-w-[221px]'>
                    <input
                        type='text'
                        id='search'
                        value={filterText}
                        onChange={e => setFilterText(e.target.value)}
                        placeholder='Search here...'
                        className='bg-bg-light border border-border w-full py-[6px] px-3 min-h-[40px] rounded-[4px] placeholder:text-text-secondary focus:outline-none'
                    />
                </div>
                <button onClick={handleClear} className="btn btn-danger">
                    Clear
                </button>
            </div>
        );
    }, [filterText, resetPaginationToggle]);

    return (
        <>
        {showMsg && (
        <CustomAlert
          message={msg}
          //  message="Test Alert Message"
          type={error ? "error" : "success"} // Set alert type based on the message
          onClose={() => {
            setError(null); // Clear error message on close
            setSuccess(null); // Clear success message on close
          }}
        />
      )}
            <Breadcrumb title="UserRoles" path="Masters / UserRoles" />
            <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                <div className='flex items-center justify-between gap-15 mb-30'>
                    <p className='text-[16px]/[19.2px] font-medium'>
                        UserRole List
                    </p>
                    <button onClick={openAddUserRoleModal} className='btn btn-primary'>
                        Add New
                    </button>
                </div>
                <div className='react-data-table'>
                    <ReactDataTable
                        columns={columnsFilter}
                        data={filteredItems}
                        pagination
                        paginationResetDefaultPage={resetPaginationToggle}
                        subHeader
                        subHeaderComponent={subHeaderComponentMemo}
                    />
                </div>
            </div>
            {addUserRoleModal &&
                   <>
                   <div className="fixed p-15 w-full max-w-[600px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]">
                     <div className="py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light">
                       <h5 className="text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                         Add UserRole
                       </h5>
                       <div className="my-10 md:px-10 px-[7px] max-h-[60vh] overflow-auto cus-scrollbar">
                         <div className="grid grid-cols-12 gap-20">
                           <div className="form-group flex col-span-12">
                             <input
                               type="text"
                               id="id"
                               name="id"
                               placeholder="ID"
                               value={userRoleData.Id}
                               onChange={handleChange}
                             />
                           </div>
                           <div className="form-group flex col-span-12">
                             <input
                               type="text"
                               id="name"
                               name="name"
                               placeholder="Name"
                               value={userRoleData.Name}
                               onChange={handleChange}
                             />
                           </div>
                           <div className="form-group flex col-span-12">
                             <input
                               type="text"
                               id="narration"
                               name="narration"
                               placeholder="Narration"
                               value={userRoleData.Narration}
                               onChange={handleChange}
                             />
                           </div>
                           <div className="form-group flex col-span-12">
                             <input
                               type="text"
                               id="code"
                               name="code"
                               placeholder="Code"
                               value={userRoleData.Code}
                               onChange={handleChange}
                             />
                           </div>
                           <div className="form-group flex col-span-12">
                             <input
                               type="text"
                               id="profitCenterId"
                               name="profitCenterId"
                               placeholder="Profit Center ID"
                               value={userRoleData.ProfitCenterId}
                               onChange={handleChange}
                             />
                           </div>
                           <div className="form-group flex col-span-12">
                             <input
                               type="text"
                               id="userId"
                               name="userId"
                               placeholder="User ID"
                               value={userRoleData.UserId}
                               onChange={handleChange}
                             />
                           </div>
                           <div className="form-group flex col-span-12">
                             <input
                               type="text"
                               id="systime"
                               name="systime"
                               placeholder="System Time"
                               value={userRoleData.Systime}
                               readOnly
                             />
                           </div>
                           {/* <div className="form-group flex col-span-12">
                             <input
                               type="text"
                               id="userRoleName"
                               name="userRoleName"
                               placeholder="UserRole Name"
                               value={userRoleData.UserRoleName}
                               onChange={handleChange}
                             />
                           </div>
                           <div className="form-group flex md:col-span-6 col-span-12">
                             <input
                               type="text"
                               id="userRoleHead"
                               name="userRoleHead"
                               placeholder="UserRole Head"
                               value={userRoleData.UserRoleHead}
                               onChange={handleChange}
                             />
                           </div>
                           <div className="form-group flex md:col-span-6 col-span-12">
                             <input
                               type="text"
                               id="totalEmployee"
                               name="totalEmployee"
                               placeholder="Total Employees"
                               value={userRoleData.TotalEmployee}
                               onChange={handleChange}
                             />
                           </div> */}
                         </div>
                       </div>
                       <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
                         <button onClick={openAddUserRoleModal} className="btn btn-outline-secondary">
                           Cancel
                         </button>
                         <button onClick={handleSubmit} className="btn btn-primary">
                           Add
                         </button>
                       </div>
                     </div>
                   </div>
                   <div
                     onClick={openAddUserRoleModal}
                     className="fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]"
                   ></div>
                 </>
            }
        </>
    )
}
